export default __webpack_public_path__ + "static/media/small_cv_sample2.ce81f0ba.png";